import { createStore, Store } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { initialState, rootReducer } from './reducers'

export type StoreState = ReturnType<typeof initialState>
export type ReduxStore = Store<StoreState>

const persistConfig = {
  key: 'onepas_cms',
  whitelist: ['auth', 'searchQuery', 'searchQueryMessages'],
  storage
}
const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = createStore(persistedReducer, composeWithDevTools())

export const persistor = persistStore(store)
export default store

// export const store = (state = initialState()) => {
//   return createStore(rootReducer, state, composeWithDevTools())
// }
